import { create } from 'zustand';
import { BillboardData } from '../dto/EntityRepository';
import { DisplaySize } from '../enum/EnumRepository';

interface BillboardState {
  billboard: BillboardData | null;
  hasChanged: boolean;
  imageChanged: boolean;
  setBillboard: (value: BillboardData) => void;
  updateBillboard: (updates: Partial<BillboardData>) => void;
  updateImage: (originUrl: string, width: number, height: number) => void;
  updateDisplaySize: (displaySize: DisplaySize) => void;
  clearBillboard: () => void;
}

export const useBillboardStore = create<BillboardState>((set) => ({
  billboard: null,
  hasChanged: false,
  imageChanged: false,
  setBillboard: (billboard) => set({ billboard, hasChanged: false, imageChanged: false }),
  updateBillboard: (updates) =>
    set(({ billboard }) => ({
      billboard: billboard ?
        { ...billboard, ...updates }
        : null,
      hasChanged: true
    })),

  updateImage: (originUrl: string, width: number, height: number) =>
    set(({ billboard }) => ({
      billboard: billboard ? {
        ...billboard,
        uploadFile: {
          ...billboard.uploadFile,
          originUrl,
          width,
          height,
        }
      } : null,
      hasChanged: true,
      imageChanged: true,
    })),
  updateDisplaySize: (displaySize: DisplaySize) =>
    set(({ billboard }) => ({
      billboard: billboard ? {
        ...billboard,
        displaySize,
      } : null,
      hasChanged: true,
    })),
  clearBillboard: () => set({ billboard: null, hasChanged: false, imageChanged: false }),
}));